<template>
  <div class="full-height">
    <div v-if="group.portal == '3'" class="full-height">
      <v-card class="pa-0 full-height" id="card-config-preview">
        <v-card-text class="pa-0 full-height">
          <v-container fluid class="full-height pa-0">
            <v-row class="full-height" no-gutters>
              <v-col cols="12" md="8" class="border-right relative full-height">
                <div class="text-center full-height">
                  <div v-if="group.portal === 3" class="full-height">
                    <iframe
                      :src="previewUrl"
                      style="
                        width: 100%;
                        max-width: 400px;
                        height: calc(100% - 16px);
                        overflow: auto;
                      "
                      class="mt-2"
                      v-if="previewUrl"
                    />
                    <v-subheader v-else>
                      Veuillez sélectionner un portail du groupe pour le
                      visualiser.
                    </v-subheader>
                  </div>
                  <div v-else>Le groupe n'est pas en V5</div>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="pa-0 full-height">
                <v-row no-gutters class="full-height">
                  <v-col cols="12" class="pa-0" id="model-title">
                    <v-card class="pa-0" flat>
                      <v-card-title>
                        <div v-if="group.isBuiltIn">
                          Template : {{ group.portalOptions.name }}
                        </div>
                        <div v-else>
                          <span>Modèle : {{ group.portalName }}</span>
                        </div>
                      </v-card-title>
                    </v-card>
                    <v-divider></v-divider>
                    <v-card class="pa-0" flat>
                      <v-card-title
                        >Choix du portail de visualisation</v-card-title
                      >
                      <v-card-text>
                        <v-select
                          :items="groupPortals"
                          :disabled="!hasPortals"
                          :loading="loadingPortals"
                          v-model="selectedPreviewPortal"
                          return-object
                          item-value="id"
                          item-text="description"
                          :hide-details="!loadingPortals && hasPortals"
                          :hint="
                            !loadingPortals && !hasPortals
                              ? 'Le groupe n\'a pas de portail en héritage'
                              : ''
                          "
                          dense
                          :persistent-hint="!loadingPortals && !hasPortals"
                        ></v-select>
                      </v-card-text>
                    </v-card>
                    <v-divider></v-divider>
                  </v-col>
                  <div
                    class="pa-0 thin-scroll overflow-y"
                    :style="
                      'height: calc(100% - ' + configScrollHeightOffset + 'px)'
                    "
                  >
                    <portal-configuration-presentation-settings
                      :isInherit="group.isInherit"
                      :isBuiltIn="group.isBuiltIn"
                      :portalOptionsId="group.portalOptionsId"
                      :isGroup="true"
                      :id="String(group.id)"
                      :portalConfigurationModel="group.portalConfigurationModel"
                      :group="group"
                      :partner="group.partner"
                      :portalConfiguration.sync="group.portalConfiguration"
                      :rules="rules"
                      v-on:mounted="computeConfigScrollOffset"
                      ref="editSettings"
                      @update:portal-settings="updatePortalSettingsTab"
                      :loadingSettingsPortal="loadingSettingsPortal"
                    ></portal-configuration-presentation-settings>
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
    <div v-else>
      <v-alert type="warning">
        Il faut migrer le groupe pour pouvoir le configurer.
      </v-alert>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  ref,
  computed,
  watch,
  toRefs,
  onBeforeMount,
  toRef,
} from "@vue/composition-api";
import global from "@/composables/global";
import { useGroup } from "@/composables/group";
import PortalConfigurationPresentationSettings from "@/components/PortalConfiguration/PortalConfigurationPresentationSettings.vue";
import { useIframePreview } from "@/composables/iframe-preview";
import { useRoles } from "../../composables/roles";
import { useClientPortal } from "@/composables/client-portal";

export default defineComponent({
  components: {
    PortalConfigurationPresentationSettings,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* Import des API */
    const { data, updatePortalConfigurationSparse } = useGroup();
    const { isGrantedUser } = useRoles();
    const { data: portalData, listClientPortals } = useClientPortal();
    const configurationformData = ref({});

    /* Cycle de vie */
    onBeforeMount(async () => {
      await listClientPortals({
        group: props.group.id,
        isActive: true,
        isInheritOnly: 1,
      });
      groupPortals.value = portalData.clientPortals.data;
    });

    /* Variables */
    const previewUrl = ref("");
    const configScrollHeightOffset = ref(0);
    const selectedPreviewPortal = ref(null);
    const baseUrl = config.VUE_APP_API_PUBLIC;
    const loadingSettingsPortal = ref(false);
    const editSettings = ref(null);
    const groupPortals = ref([]);

    /* Computed */
    const hasPortals = computed(function () {
      return groupPortals.value.length > 0;
    });
    const selectedPortalNas = computed(function () {
      if (selectedPreviewPortal.value) {
        const portalActiveNasTab = selectedPreviewPortal.value.nas.filter(
          (x) => x.active == 1
        );
        if (portalActiveNasTab.length > 0) {
          return portalActiveNasTab[0];
        } else {
          return null;
        }
      } else {
        return null;
      }
    });

    /* Méthodes */
    const computeConfigScrollOffset = function () {
      const modelTitleElement = document.getElementById("model-title");
      if (modelTitleElement) {
        setTimeout(function () {
          configScrollHeightOffset.value = modelTitleElement.clientHeight + 36; //36 = hauteur du bouton enregistrer
        }, 0);
      }
    };
    const { reloadPreview } = useIframePreview();

    const updatePortalSettingsTab = async function () {
      loadingSettingsPortal.value = true;
      configurationformData.value = {
        user_form: props.group.portalConfiguration.user_form,
        basic_presentation: props.group.portalConfiguration.basic_presentation,
        full_presentation: props.group.portalConfiguration.full_presentation,
        has_card_at_reception:
          props.group.portalConfiguration.has_card_at_reception,
        has_pms_marseo: props.group.portalConfiguration.has_pms_marseo,
        hide_access_codes: props.group.portalConfiguration.hide_access_codes,
        hide_free_access_codes:
          props.group.portalConfiguration.hide_free_access_codes,
        ad: props.group.portalConfiguration.ad,
        is_luxury: props.group.portalConfiguration.is_luxury,
        brand_newsletter: props.group.portalConfiguration.brand_newsletter,
      };
      await updatePortalConfigurationSparse(
        String(props.group.id),
        configurationformData.value
      );
      loadingSettingsPortal.value = false;
      reloadPreview();
    };

    /* Watchers */
    watch(
      () => selectedPortalNas.value,
      (newValue) => {
        if (newValue) {
          previewUrl.value = `${baseUrl}login-url.php?id=${newValue.nasIdentifier}`;
        } else {
          previewUrl.value = "";
        }
      }
    );

    return {
      ...toRefs(data),
      previewUrl,
      configScrollHeightOffset,
      computeConfigScrollOffset,
      global,
      reloadPreview,
      hasPortals,
      selectedPortalNas,
      loadingSettingsPortal,
      updatePortalSettingsTab,
      selectedPreviewPortal,
      editSettings,
      isGrantedUser,
      groupPortals,
      loadingPortals: toRef(portalData, "isLoading"),
    };
  },
});
</script>
